import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { CgMenuRightAlt } from 'react-icons/cg';
import { IoMdClose } from 'react-icons/io';
import { isProviderAllowed } from '../../../utils/app';

const UserHeaderHelper = (props) => {
    const { links, doLogout, toggleMenu, isMenuOpen, user, whatsappUrl } = props;

    const filteredLinks = links?.filter(
      (link) => !(!isProviderAllowed(user?.provider) && link.to === '/security')
    );

    return (
        <>
            <div className="nav d-lg-flex align-self-end header-lg">
              <ul>
                {
                    links && filteredLinks.map((link, index) => {
                        const PREFIX = link.prefix ? link.prefix : '';
                        return (
                            <li key={index}>
                                <NavLink
                                    to={PREFIX + link.to}
                                >
                                    {link.name}
                                </NavLink>
                            </li>
                        )
                    })
                }
                <li>
                    <Link disabled={!whatsappUrl} target={"_blank"} to={whatsappUrl}>Join the chat room</Link>
                </li>
                </ul>
            </div>

              <div style={{ flex: '0 0 12%' }} className="buttons header-lg-buttons">
                <div className="logout-button">
                  <Link to="/" className="button " onClick={doLogout}>
                    Logout
                  </Link>
                </div>
              </div>




            <div className="menu-toggle" onClick={toggleMenu}>
              <CgMenuRightAlt color={"white"} size={30}/>
            </div>



            <div className={`header-menu-mobile  ${isMenuOpen ? "show" : " "}`}>
              <div
                className={`menu-toggle  ${isMenuOpen ? "active" : " "}`}
                onClick={toggleMenu}>
                <IoMdClose color={"white"} size={30}/>
              </div>
              <div className="nav">
                <ul>
                {
                    links && filteredLinks.map((link, index) => {
                        const PREFIX = link.prefix ? link.prefix : '';
                        return (
                            <li key={index}>
                                <NavLink
                                    to={PREFIX + link.to}
                                    onClick={toggleMenu}
                                >
                                    {link.name}
                                </NavLink>
                            </li>
                        )
                    })
                }
                <li>
                    <Link disabled={!whatsappUrl} target={"_blank"} to={whatsappUrl}>Join the chat room</Link>
                </li>
            
                </ul>
              </div>

              <div className="buttons">
                <div className="logout-button">
                  <Link to="/" className="button " onClick={() => { doLogout(); toggleMenu()}}>
                    Logout
                  </Link>
                </div>
              </div>
            </div>
        </>
    )
}

export default UserHeaderHelper
